import { exportExcel } from "@api/stores/salesInvoiceItemReport/exportExcel/api";
import { exportPDF } from "@api/stores/salesInvoiceItemReport/exportPDF/api";
import { exportSinglePDF } from "@api/stores/salesInvoiceItemReport/exportSinglePDF/api";
import { stats } from "@api/stores/salesInvoiceItemReport/stats/api";
import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam } from "./path";
import type {
  ISalesInvoiceItemReportGetAllParams,
  ISalesInvoiceItemReportResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<ISalesInvoiceItemReportResponse>>,
  IPathBaseParam,
  IPaginationParams & ISalesInvoiceItemReportGetAllParams
>("stores.salesInvoiceItemReport");

export const salesInvoiceItemReport = {
  ...getAllApis,
  stats,
  exportPDF,
  exportExcel,
  exportSinglePDF,
};
